export const SupportedLanguage = {
  EN: "en",
  HR: "hr",
} as const;

export type SupportedLanguage =
  (typeof SupportedLanguage)[keyof typeof SupportedLanguage];
